import { FC, lazy } from 'react';
import { Stack } from 'src/components/layout/stack';
import { Heading } from 'src/components/text/heading';

const Page = lazy(() => import('./page'));

export const PrimaryRemitReportsOverview: FC<{}> = ({}) => {
  return (
    <Stack gap={2}>
      <Stack flow="column" justifyContent="space-between">
        <Heading mode="title" data-testid="primary-tradings-reporting">
          REMIT Reports
        </Heading>
      </Stack>

      <Page />
    </Stack>
  );
};
